module.exports = __webpack_public_path__ + "img/banner.719f4585.png";